import { LicenseMonthlyAddonsFormController } from '../controller/LicenseMonthlyAddonsFormController';
import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { Feature, FeatureFlag } from '@nirvana/shared/constants';
import { CompanyActionContext } from '../../../../company/common/types/CompanyActionContext';
import { MonthlyProductType } from '../../../types/MonthlyProductType';
import { Observable } from 'rxjs';
import { FormGroupValue } from '../../../../ui/gzForm/formGroup/types/form-group-value';
import { AddonFormType } from '../types/AddonFormType';
import _ from 'lodash';
import { CompanyType } from '../../../../company/types/company-type';
import { CompanyFeatures } from '../../../../company/types/company-data';

export class LicenseMonthlyAddonsFormWebComponent extends BaseWebComponentElement {
  public controller!: LicenseMonthlyAddonsFormController;
  public context: CompanyActionContext;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: LicenseMonthlyAddonsFormController,
    });
  }

  public set childCompanyType(childCompanyType: CompanyType) {
    this.controller.setChildCompanyType(childCompanyType);
  }

  public set usableProduct(usableProduct: MonthlyProductType | undefined) {
    this.controller.setUsableProduct(usableProduct);
  }

  public set delegableProducts(delegableProducts: MonthlyProductType[] | undefined) {
    this.controller.setDelegableProducts(delegableProducts);
  }

  public set availableFeatures(availableFeatures: Feature[] | undefined) {
    this.controller.setAvailableFeatures(availableFeatures);
  }

  public set featuresInTrial(featuresInTrial: FeatureFlag[] | undefined) {
    this.controller.setFeaturesInTrial(featuresInTrial);
  }

  public hideAddons(features: FeatureFlag[]): void {
    this.controller.hideAddons(features);
  }

  public isAnyAddonVisible(): boolean {
    return this.controller.isAnyAddonVisible();
  }

  public setCheckedValueForFeatureAddons(features: FeatureFlag[], checkedValue: boolean): void {
    this.controller.setCheckedValueForFeatureAddons(features, checkedValue);
  }

  public set formType(formType: AddonFormType) {
    this.controller.setFormType(formType);
  }

  public set isTrial(isTrial: boolean) {
    this.controller.setIsTrial(isTrial);
  }

  public get valid$(): Observable<boolean> {
    return this.controller.view.formGroup.valid$;
  }

  public set value(formValue: FormGroupValue) {
    this.controller.updateToggles(formValue as CompanyFeatures);
  }

  public get value(): FormGroupValue {
    return _.clone(this.controller.view.formGroup.value);
  }

  public setBundleId(bundleId: number) {
    this.controller.setBundleId(bundleId);
  }
}
